
<template>
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="formInline" class="demo-form-inline toolbar" style="padding-bottom: 0px"
        @submit.native.prevent>
        <el-form-item label="设备编号">
          <el-input v-model.trim="formInline.inputdeviceno" placeholder="请输入设备编号" clearable
            @keyup.enter.native.prevent="enterSearchMember" style="width: 160px"></el-input>
        </el-form-item>
        <el-form-item label="设备类型">
          <el-select v-model="formInline.deviceType" clearable style="width: 160px">
            <el-option v-for="item in deviceTypeList" :key="item.type" :label="item.name" :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="绑定位置">
          <el-input
            v-model.trim="formInline.location"
            placeholder="请输入绑定位置"
            style="width: 160px"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" plain class="el-icon-plus" @click="dialogFormVisible = true">新增</el-button>
          <el-button type="info" icon="el-icon-upload" plain @click="downAll">导出</el-button>
          <el-button type="info" icon="el-icon-upload" plain @click="intoList">导入</el-button>
          <el-button type="info" icon="el-icon-document" plain @click="downLoad">导入模板下载</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table :data="list" style="width: 100%" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
          <el-table-column label="设备编号" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.deviceNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备类型" :show-overflow-tooltip="true" :formatter="formatType" align="center">
          </el-table-column>
          <el-table-column label="设备名称" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.deviceName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备描述" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.location?'已开通':'未开通' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250" align="center">
            <template slot-scope="scope">
              <el-button type="success" size="mini" v-if="scope.row.location == null || scope.row.location == ''" plain
                @click="handleBangdi(scope.$index, scope.row)">开通</el-button>
              <el-button type="primary" size="mini" v-else plain
                @click="handleJiebang(scope.$index, scope.row)">关闭</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" layout="total, prev, pager, next" :total="totalDataNumber" :page-size="pageSize"
          align="center" class="fenye"></el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog title="新增设备信息" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
        :close-on-press-escape="false" class="dangerbuttonxz" @close="closexz">
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="设备编号" :label-width="formLabelWidth" prop="xzdate">
            <el-input v-model.trim="form.xzdate" placeholder="请输入设备编号"></el-input>
          </el-form-item>
          <el-form-item label="设备类型" :label-width="formLabelWidth">
            <el-select v-model="form.deviceType" style="width: 100%;">
              <el-option v-for="item in deviceTypeList" :key="item.type" :label="item.name" :value="item.type">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备名称" :label-width="formLabelWidth" prop="xzname">
            <el-input v-model.trim="form.xzname" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" :label-width="formLabelWidth" prop="xzsec">
            <el-input v-model.trim="form.xzsec" type="textarea" :rows="3" placeholder="请输入设备描述"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelxz">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')" :loading="addLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 弹出修改-->
      <el-dialog title="修改设备信息" :visible.sync="dialogFormEdit" :close-on-click-modal="false"
        :close-on-press-escape="false" class="dangerbuttonedit">
        <el-form ref="formedit" :model="formedit" :rules="rules">
          <el-form-item label="设备编号" :label-width="formLabelWidth" prop="editdate">
            <el-input disabled v-model.trim="formedit.editdate" auto-complete="off" placeholder="请输入设备编号"></el-input>
          </el-form-item>
          <el-form-item label="设备名称" :label-width="formLabelWidth" prop="editname">
            <el-input v-model.trim="formedit.editname" auto-complete="off" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" :label-width="formLabelWidth" prop="editsec">
            <el-input v-model.trim="formedit.editsec" auto-complete="off" type="textarea" :rows="3"
              placeholder="请输入设备描述"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogFormEdit = false">取 消</el-button>
          <el-button type="primary" @click="submitFormEdit('formedit')" :loading="editLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 表格导入的dialog -->
      <el-dialog title="设备导入" width="30%" :visible.sync="dialogVisible" :close-on-click-modal="false"
        @close="closeDialogReset">
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-row>
              <el-col :span="24">
                <input type="file" ref="file" id="file" @change="getUrl" />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click.native="intoForm">确定</el-button>
        </div>
      </el-dialog>

      <!-- 绑定设备 -->
      <el-dialog title="绑定设备" :visible.sync="dialogFormBangdi" :close-on-click-modal="false"
        :close-on-press-escape="false" class="bangdilocation">
        <el-form ref="formBangdi" :model="formBangdi">
          <el-form-item label="设备编号 :" :label-width="formLabelWidth" prop="bindDeviceNo">
            <span>{{ formBangdi.bindDeviceNo }}</span>
          </el-form-item>
          <el-form-item label="老人姓名 :" :label-width="formLabelWidth" prop="oldmanName">
            <el-autocomplete v-model.trim="formBangdi.oldName" auto-complete="off" placeholder="搜索老人姓名"
              :fetch-suggestions="querySearchAsync" @select="handleOlderSelect" style="width: 240px">
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="房间床位 :" :label-width="formLabelWidth" prop="bedId">
            <el-cascader
              ref="refbed"
              style="width: 240px"
              :props="{ checkStrictly: true }"
              :value="cascadervalue"
              :options="optionsBed"
              @change="handleChangeBed"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="绑定位置 :" :label-width="formLabelWidth" prop="location">
            <el-input v-model.trim="formBangdi.location" auto-complete="off" style="width: 240px"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogFormBangdi = false">取 消</el-button>
          <el-button type="primary" @click="submitFormBangdi('formBangdi')">确 定</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      selectOldmanList: [], //select下拉菜单的老人集合
      addLoading: false,
      editLoading: false,
      formInline: {
      },

      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      dialogFormBangdi:false,
      cascadervalue: [], //Cascader级联选择器集合的值默认为空
      optionsBed: [], //床位号的Cascader级联选择器集合
      formBangdi:{
      },
      deviceno: "",
      list: [], //返回的结果集合
      allList: [], //返回紧急按钮的集合  全部数据
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      // 新增表单dialog
      dialogFormVisible: false,
      dialogVisible: false,
      form: {
        xzdate: "",
        xzsec: "",
        xzname: "",
        deviceType: "",
      },
      formLabelWidth: "120px",
      //修改表单dialog
      dialogFormEdit: false,
      formedit: {
        editdate: "",
        editname: "",
        editsec: "",
      },
      rules: {
        xzdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          { min: 1, max: 30, message: "长度在 1到 30 个字符" },
        ],
        xzsec: [
          { min: 1, max: 100, message: "长度在 1到 100 个字符" },
        ],
        xzname: [
          { min: 1, max: 30, message: "长度在 1到 30 个字符" },
        ],
        deviceType: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
        ]
      },
      fileFlag: false,
      deviceTypeList: [
        { type: 41, name: "测温定位手环" },
        { type: 39, name: "火柴人摄像头" },
        { type: 37, name: "4G血压计" },
        { type: 49, name: "无线网卡" },
        { type: 36, name: "体检一体机" },
        { type: 29, name: "健康监测雷达" },
        { type: 28, name: "智能魔盒" },
        { type: 35, name: "呼叫按钮" },
        { type: 34, name: "呼叫主机" },
        { type: 49, name: "智能水表" },
        { type: 31, name: "睡眠检测带" },
        { type: 30, name: "跌倒雷达" },
        { type: 27, name: "门磁感应器" },
        { type: 26, name: "溢水报警器" },
        { type: 25, name: "燃气报警器" },
        { type: 24, name: "烟雾报警器" },
        { type: 23, name: "紧急呼叫器" },
        { type: 22, name: "红外探测器" },
        { type: 21, name: "萤石摄像头" },
        { type: 20, name: "巡更点" },
        { type: 19, name: "巡更棒" },
        { type: 11, name: "多功能随访仪" },
        { type: 10, name: "护工手表" },
        { type: 14, name: "门禁控制卡" },
        { type: 8, name: "门禁标签" },
        { type: 7, name: "门禁读卡器" },
        { type: 4, name: "4G呼叫网关" },
        { type: 1, name: "孝心手环" },
      ]
    };
  },
  methods: {
    handleBangdi(index, row) {
        this.formBangdi={
          bindDeviceNo:row.deviceNo,
          deviceId:row.id,
          oldmanId:"",
          location:"",
          oldName:"",
          bedId:"",
          roomId:""
        }
        this.dialogFormBangdi = true;
    },
    submitFormBangdi() {
      if(this.formBangdi.oldName == null || this.formBangdi.oldName == ''){
        this.formBangdi.oldmanId = '';
      }
      console.log(this.formBangdi);
      let param = {
        deviceId: this.formBangdi.deviceId,
        bindType: "1",
        location: this.formBangdi.location,
        oldmanId: this.formBangdi.oldmanId,
        oldmanName: this.formBangdi.oldName,
        bedId:this.formBangdi.bedId,
        roomId:this.formBangdi.roomId,                                                              
        oldIdCard: this.formBangdi.oldIdCard,
      };
      this.$postJson("dmc/commonDevice/bindLocation", param).then(res=>{
        if (res.code == "10061031") {
          setTimeout(() => {
            this.$message({
              message: "设备已经梆定",
              type: "error",
            });
          }, 300);
        } else if (res.code == "10061065") {
          setTimeout(() => {
            this.$message({
              message: res.message,
              type: "error",
            });
          }, 300);
        } else{
          setTimeout(() => {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.getTableData();
            this.dialogFormBangdi = false;
          }, 300);
        }
      })

    },
    //解绑
    handleJiebang(index, row) {
      this.$confirm("此操作将解除绑定, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false,
      })
        .then(() => {
          this.$postJson("dmc/commonDevice/unBindLocation/" + row.id).then(
            (res) => {
              //先判断绑定类型是否为 1  老人类型   为老人类型才循环添加值
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              }, 300);
            }
          );
        })
    },
      /* 
      模糊查询老人
      */
      querySearchAsync(queryString, cb) {
      let param = {
        oldName: queryString
      };
      this.$postJson("omc/Oldman/quickShowAllOldMan", param).then((res) => {
        var list = [{}];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
        }
      });
    },
    /* 
      根据模糊查询老人返回老人id
    */
    handleOlderSelect(item) {
      this.formBangdi.oldmanId = item.oldmanId;
      this.formBangdi.location = item.oldAddress;
      this.formBangdi.oldIdCard = item.oldIdCard;
    },
    handleChangeBed(val) {
      let refbedStr = "";
      console.log(this.$refs.refbed.getCheckedNodes()[0].pathLabels);
      this.$refs.refbed.getCheckedNodes()[0].pathLabels.forEach((item, index) => {           
        if (this.$refs.refbed.getCheckedNodes()[0].pathLabels.length - 1 == index) {
          refbedStr += item;
        } else {
          refbedStr += item + "-";
        }
      });
      if(val.length == 3){
        this.formBangdi.roomId = val[2];
        this.formBangdi.bedId = "";
        this.formBangdi.location = refbedStr;
      }else if (val.length == 4){
        this.formBangdi.roomId = val[2]; 
        this.formBangdi.bedId = val[3]; 
        this.formBangdi.location = refbedStr;
      }else{
        this.formBangdi.bedId = ""; 
        this.formBangdi.roomId = ""; 
      }
    },
    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.inputdeviceno != null) {
        if (this.formInline.inputdeviceno == "") {
          this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
        } else {
          this.getTableData(
            this.formInline.inputdeviceno,
            (this.pageNum = 1),
            (this.pageSize = 8)
          );
        }
      }
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    formatType(row) {
      var typeStr = "";
      this.deviceTypeList.forEach(item => {
        if (item.type == row.deviceType) {
          typeStr = item.name;
        }
      })
      return typeStr;
    },
    // 点击弹出修改信息的弹窗
    handleEdit(index, row) {
      (this.dialogFormEdit = true), //打开修改弹窗
        this.listIndex = index; //记录索引
      //this.formedit=row;//记录数据
      this.formedit = Object.assign({}, row); //深拷贝记录
      //将对应行所对的表格值赋给input框
      this.$set(this.formedit, "editdate", row.deviceNo);
      this.$set(this.formedit, "editsec", row.remark);
      this.$set(this.formedit, "editname", row.deviceName);
    },

    //点击修改弹窗的 确定按钮提交修改的数据
    submitFormEdit(datainfo) {
      //正则匹配规则rules
      this.$refs[datainfo].validate((valid) => {
        //判断数据是否存在
        if (valid) {
          let param = {
            id: this.formedit.id,
            remark: this.formedit.editsec,
            deviceName: this.formedit.editname,
            deviceNo: this.formedit.editdate,
          };
          this.editLoading = true;
          this.$postJson("dmc/commonDevice/edit", param)
            .then((res) => {
              this.editLoading = false;
              this.dialogFormEdit = false; //关闭修改弹窗
              this.getTableData();
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success",
                  });
                }, 300);
                console.log("修改成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error",
                  });
                }, 300);
              }
            })
            .catch((res) => {
              this.$message({
                type: "error",
                message: res.message,
              });
            });
        } else {
          console.log("修改失败!");
          return false;
        }
      });
    },
    //删除
    handleDelete(index, row) {
      if (row.bindType == null) {
        this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false,
        })
          .then(() => {
            this.$postJson("dmc/commonDevice/deleteById/" + row.id).then((res) => {
              if (res.code == 200) {
                this.getTableData();
                this.$message({
                  type: "success",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            });
          })
      } else {
        this.$message({
          type: "error",
          message: "该设备已经被绑定，请先解绑后再进行删除!",
        });
      }
    },
    //关闭新增的dialog
    closexz() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },
    //点击新增取消  重置表单以及验证
    cancelxz() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },
    addDevice() {
      let param = {
        remark: this.form.xzsec,
        deviceName: this.form.xzname,
        deviceNo: this.form.xzdate,
        deviceType: this.form.deviceType,
      };
      this.addLoading = true;
      this.$postJson(
        "dmc/commonDevice/add",
        param
      ).then(res => {
        if (res.code == 200) {
          this.addLoading = false;
          this.dialogFormVisible = false;
          this.$refs.form.resetFields(); //移除校验结果并重置字段值
          this.getTableData();
        } else {
          this.addLoading = false;
        }
      }).catch(err => {
        this.addLoading = false;
      });
    },
    // 新增弹出框点击确定提交信息
    submitForm(datainfo) {
      this.$refs[datainfo].validate((valid) => {
        if (valid) {
          this.addDevice();
        } else {
          return false;
        }
      });
    },
    //获取分页的紧急按钮数据  只获取pageSize条数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceNo: this.formInline.inputdeviceno,
        location: this.formInline.location,
        deviceType: this.formInline.deviceType
      };
      this.loading = true;
      this.$postJson("dmc/commonDevice/queryDeviceListWithPage", param).then(
        (res) => {
          if (res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            this.list = res.result.list;
            this.loading = false;
          } else {
            this.list = [];
            this.totalDataNumber = 0;
            setTimeout(() => {
              this.loading = false;
            }, 800);
          }
        }
      );
    },
    getBuildingShowAll() {
      let parma = {
        buildingName: "", //楼栋名称
      };
      this.$postForm("omc/Building/showAlls", parma).then((res) => {
        //1层循环取出楼栋信息  判断是否存在
        if (res.result != null) {
          res.result.forEach((item, index) => {
            var floorList = [];
            this.optionsBed.push({
              value: item.buildingId,
              label: item.buildingName,
              children: floorList,
            });
            //2层循环取出楼层信息  判断是否存在
            if (item.floorList != null) {
              item.floorList.forEach((item2, index) => {
                var roomList = [];
                floorList.push({
                  value: item2.floorNo,
                  label: item2.floorNo + "层",
                  children: roomList,
                });
                //3层循环取出房间roomId  判断是否存在
                if (item.roomList != null) {
                  item2.roomList.forEach((item3, index) => {
                    var bedList = [];
                    roomList.push({
                      value: item3.roomId,
                      label: item3.roomNo,
                      children: bedList,
                    });
                    //4层循环取出床位bedId  判断是否存在
                    if (item3.bedList != null) {
                      item3.bedList.forEach((item4, index) => {
                        bedList.push({
                          value: item4.bedId,
                          label: item4.bedNo + "号床",
                        });
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
    },
    //导入
    intoList() {
      this.dialogVisible = true;
    },
    //确认导入
    getUrl(event) {
      let file = event.target.files;
      console.log(file);
      this.fileFlag = true; //by guo 2020-8-4-15:04添加
      this.formData = new FormData();
      this.formData.append("file", file[0]);
    },
    //确认导入
    intoForm() {
      if (this.fileFlag) {
        this.$postFormData(
          "dmc/propertyManagement/merchantToLead",
          this.formData
        ).then((res) => {
          this.dialogVisible = false;
          this.formData = {};
          this.fileFlag = false;
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.getTableData();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      } else {
        this.$message({ message: "请选择文件", type: "error" });
      }
    },
    closeDialogReset() {
      this.$refs.file.value = ""; // 清空file文件
    },
    //模板下载
    downLoad() {
      window.location.href = baseURL + "dmc/api/downTemplate";
    },
    downAll(){
      window.location.href =
        baseURL +
        `dmc/api/downDeviceList?groupId=${sessionStorage.getItem(
          "groupId"
        )}`;
    },
    //点击查询
    onSubmit() {
      this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getTableData();
    },
  },
  created() {
    //组件创建完后获取数据，
    //此时 data 已经被 observed 了
    this.getTableData();
    this.getBuildingShowAll();
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.buttonlist {
  .buttonlist-m {
    padding: 10px 0 0 5px;
  }
}

// 修改element-ui默认的样式
.del {
  color: red !important;
}

.fangqu {
  color: green !important;
}

.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}

//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

//新增的dialog
@media screen and (min-width: 1200px) {
  ::deep .dangerbuttonxz .el-dialog {
    width: 30% !important;
  }
}

//修改的dialog
@media screen and (min-width: 1200px) {
  ::deep .dangerbuttonedit .el-dialog {
    width: 30% !important;
  }
}

//绑定紧急按钮位置和房间的dialog
@media screen and (min-width: 1200px) {
  ::deep .bangdilocation .el-dialog {
    width: 30% !important;
  }
}

@media screen and (min-width: 600px) and (max-width: 1199px) {
  ::deep .bangdilocation .el-dialog {
    width: 55% !important;
  }
}
</style>